export default __webpack_public_path__ + "static/media/hearables.29306941.jpg";